import axios from "axios";
import { API_BASE_URL, THIRD_PARTY_API_BASE_URL, THIRD_PARTY_PDF_BASE_URL, THIRD_PARTY_API_KEY, THIRD_PARTY_USER_ID } from "../../config/Config";

// <----------------- User Login ----------------------->
export const Global_Dashboard = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/dashboard`)
        return response
    } catch (error) {
        return error
    }
}

// <------------ Settings ------------------>
export const Global_Settings = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/settings`)
        return response
    } catch (error) {
        return error
    }
}

// <------------ home Page Api's --------------->
export const Get_Home_Page = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-home`)
        return response
    } catch (error) {
        return error
    }
}

// <------------Product list Api --------------------->
export const Get_Product_List = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-product`)
        return response
    } catch (error) {
        return error
    }
}
// <------------terms_conditions Api's --------------->
export const Get_Terms_Conditions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/policy-data`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_Privacy_Policy = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/privacy-policy`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_return_policy = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/return-policy`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_Faqs = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/faqs`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_About_us = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/about-us`)
        return response
    } catch (error) {
        return error
    }
}
// <------------subhmuharats Api's --------------->
export const Get_Subhmuharats = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subhmuharats`)
        return response
    } catch (error) {
        return error
    }
}

// <------------subhmuharats Api's --------------->
export const Get_Subhmuharats_Details = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subhmuharats`, {
            params: { slug },
        })
        return response
    } catch (error) {
        return error
    }
}

// <----------without Auth PoojaCategory ------------>
export const handle_fetch_master_data = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/master-data`)
        return response
    } catch (error) {
        return error
    }
}

// <---------get astrology page ------------>

export const Get_Astrology_pages = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-astrology`,
        )
        return response
    } catch (error) {
        return error
    }
}
// <----------get astrology ------------>
export const Get_Astrology_data = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-astrology`,
            {
                params: {
                    slug: slug
                }
            })
        return response
    } catch (error) {
        return error
    }
}
export const Get_Recommendation = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-Recommendation`)
        return response
    } catch (error) {
        return error
    }
}

export const Get_Custom_Designs = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/costom-design`)
        return response
    } catch (error) {
        return error
    }
}

// <-------- Get_Product_list ------------->
export const get_auth_limit_product = async ({ origin_id, shape_id, color_id, treatment_id, min_amount, max_amount }, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-limit-product`, {
            params: {
                origin_id,
                shape_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const get_limit_product = async ({ origin_id, shape_id, color_id, treatment_id, min_amount, max_amount, cut_id,
    certificate_id, composition_id }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/limit-product`, {
            params: {
                origin_id,
                shape_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount,
                cut_id,
                certificate_id,
                composition_id
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Product List ------------------->
export const get_limit_product_Details = async ({ id, category_id, subcategory_id }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/limit-product`, {
            params: {
                id,
                category_id,
                subcategory_id
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};
// curl --location --request POST 'https://rasatva.parasmesoft.in/omens/api/get-best-product?subcat_id=3'
// <---------------Best selling products------------->
export const get_selling_products = async (subcategory_id) => {
    console.log("subcategory_id:", subcategory_id);
    try {
        const response = await axios.post(`${API_BASE_URL}/get-best-product?subcat_id=${subcategory_id}`, {
            params: {

                subcat_id: subcategory_id,
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Shop by collection ------------------->

export const get_shop_by_collection = async () => {

    try {
        const response = await axios.post(`${API_BASE_URL}/get-collection`);
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Shop by collection Product ------------------->


export const get_shop_by_collection_Product = async (slug) => {

    try {
        const response = await axios.post(`${API_BASE_URL}/get-collection?slug=${slug}`, {
            params: {
                slug: slug,
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};


// <------------------ welcome note -----------> 

export const Get_Welcome_Note = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/welcome-note`);
        return response;
    } catch (error) {
        return error;
    }
};


export const send_recommendation = async (data) => {

    const dateObj = new Date(data.dob);

    // Format YYYY-MM-DD
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    const formattedDateTime = `${formattedDate} ${hours}:${minutes}:${seconds}`;

    const formdata = {
        name: data?.name,
        email: data?.email,
        mobile: data?.phone,
        gender: data?.gender,
        purpose: data?.purpose,
        budget: data?.budget,
        birth_place: data?.placeOfBirth,
        dob: formattedDate,
        birth_time: formattedDateTime
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/recommendation`, formdata)
        return response;
    } catch (error) {
        return error;
    }
};



export const custom_jewellery = async (options) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/custom-detail`,
            options.body,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        return response;
    } catch (error) {
        return error;
    }
};

export const Visitors = async (data) => {
    const bodydata = {
        ip: data?.ip,
        device: data?.device,
        page: data?.page,
        deviceId: data?.deviceId,
        browser: data?.browser
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/store-visitor`,
            bodydata,
            {
                headers: {
                    "Content-Type": "application/json",
                    "referrer": data?.referrer
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const send_Tour_Request = async (modalForm, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/store-tour`, modalForm,
            { headers: headers }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const send_newsletter = async (formData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/post-newsletter`, formData);
        return response;
    } catch (error) {
        return error;
    }
};

// <--------------get Each Page Seo--------->
export const get_Page_Seo = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-seo`);
        return response;
    } catch (error) {
        return error;
    }
};



export const Global_Searching = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-product`)
        return response
    } catch (error) {
        return error
    }
}

// <-------------- Third Party Horoscope API's ----------------->
const getHoroscopeAuthHeader = () => {
    const USER_ID = process.env.REACT_APP_ASTRO_USER_ID;
    const API_KEY = process.env.REACT_APP_ASTRO_API_KEY;
    const credentials = btoa(`${USER_ID}:${API_KEY}`);
    return {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${credentials}`,
    };
};

// Today's Horoscope
export const Get_Third_Party_Daily_Horoscope = async (zodiacName) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/sun_sign_prediction/daily/${zodiacName}`,
            { timezone: 5.5 },
            { headers: getHoroscopeAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Tomorrow's Horoscope
export const Get_Third_Party_Tomorrow_Horoscope = async (zodiacName) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/sun_sign_prediction/daily/next/${zodiacName}`,
            { timezone: 5.5 },
            { headers: getHoroscopeAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Yesterday's Horoscope
export const Get_Third_Party_Yesterday_Horoscope = async (zodiacName) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/sun_sign_prediction/daily/previous/${zodiacName}`,
            { timezone: 5.5 },
            { headers: getHoroscopeAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Monthly Horoscope
export const Get_Third_Party_Monthly_Horoscope = async (zodiacName) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/horoscope_prediction/monthly/${zodiacName}`,
            { timezone: 5.5 },
            { headers: getHoroscopeAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Weekly Horoscope
export const Get_Third_Party_Weekly_Horoscope = async (zodiacName) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/horoscope_prediction/weekly/${zodiacName}`,
            { timezone: 5.5 },
            { headers: getHoroscopeAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Yearly Horoscope
export const Get_Third_Party_Yearly_Horoscope = async (zodiacName) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/sun_sign_prediction/yearly/${zodiacName}`,
            { timezone: 5.5 },
            { headers: getHoroscopeAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// <-------------- PDF & Report API Helper ------------------->
const getPdfAuthHeader = () => {
    const USER_ID = process.env.REACT_APP_THIRD_PARTY_USER_ID;
    const API_KEY = process.env.REACT_APP_THIRD_PARTY_API_KEY;
    const credentials = btoa(`${USER_ID}:${API_KEY}`);
    return {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${credentials}`,
    };
};

// Basic Kundli PDF - uses THIRD_PARTY_PDF_BASE_URL (pdf.astrologyapi.com)
export const Get_Basic_Kundli_PDF = async (data) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_PDF_BASE_URL}/basic_horoscope_pdf`,
            data,
            { headers: getPdfAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Match Making (Kundli Matching) PDF - uses THIRD_PARTY_PDF_BASE_URL (pdf.astrologyapi.com)
export const Get_Match_Making_PDF = async (data) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_PDF_BASE_URL}/match_making_pdf`,
            data,
            { headers: getPdfAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Love Compatibility Report - uses THIRD_PARTY_API_BASE_URL (json.astrologyapi.com)
export const Get_Love_Compatibility_Report = async (data) => {
    try {
        const response = await axios.post(
            `${THIRD_PARTY_API_BASE_URL}/love_compatibility_report/tropical`,
            data,
            { headers: getPdfAuthHeader() }
        );
        return response;
    } catch (error) {
        return error;
    }
};
